<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
    @if (!is_rrhh_view()) {
      <button mat-flat-button color="accent" (click)="openCreateRemoteWorkExceptionDialog()">Crear solicitud</button>
    }
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>
      @if (is_rrhh_view() && is_rrhh_or_admin()) {
        <mat-form-field appearance="outline" class="bisual-paginator-select">
          <mat-label>Responsable</mat-label>
          <mat-select formControlName="responsible_user_id">
            <mat-option [value]="''">Todas</mat-option>
            <mat-option [value]="current_user_id">Las que gestiono yo</mat-option>
          </mat-select>
        </mat-form-field>
      }
      <mat-form-field appearance="outline" class="bisual-paginator-select">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="status">
          <mat-option [value]="''">Todos</mat-option>
          <mat-option [value]="EmployeeRequestResponsibleForAnswerStatusEnum.PENDING">Pendiente</mat-option>
          <mat-option [value]="EmployeeRequestResponsibleForAnswerStatusEnum.ACCEPTED">Aceptado</mat-option>
          <mat-option [value]="EmployeeRequestResponsibleForAnswerStatusEnum.REJECTED">Rechazado</mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let exceptionRequest">
            {{ exceptionRequest.user.name + ' ' + exceptionRequest.user.surnames }}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let exceptionRequest">
            <span [class]="'status-badge status-' + exceptionRequest.status">
              {{ exceptionRequest.status | remoteWorkWeekdayExceptionRequestStatus }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="semana empieza en">
          <th mat-header-cell *matHeaderCellDef>Semana empieza en</th>
          <td mat-cell *matCellDef="let exceptionRequest">
            {{ exceptionRequest.monday_date | weekDateToCustomLabel }}
          </td>
        </ng-container>
        <ng-container matColumnDef="lunes">
          <th mat-header-cell *matHeaderCellDef>Lun.</th>
          <td mat-cell *matCellDef="let exceptionRequest">
            {{ exceptionRequest.has_remote_work_monday | booleanToCheckCross }}
          </td>
        </ng-container>
        <ng-container matColumnDef="martes">
          <th mat-header-cell *matHeaderCellDef>Mar.</th>
          <td mat-cell *matCellDef="let exceptionRequest">
            {{ exceptionRequest.has_remote_work_tuesday | booleanToCheckCross }}
          </td>
        </ng-container>
        <ng-container matColumnDef="miercoles">
          <th mat-header-cell *matHeaderCellDef>Mié.</th>
          <td mat-cell *matCellDef="let exceptionRequest">
            {{ exceptionRequest.has_remote_work_wednesday | booleanToCheckCross }}
          </td>
        </ng-container>
        <ng-container matColumnDef="jueves">
          <th mat-header-cell *matHeaderCellDef>Jue.</th>
          <td mat-cell *matCellDef="let exceptionRequest">
            {{ exceptionRequest.has_remote_work_thursday | booleanToCheckCross }}
          </td>
        </ng-container>
        <ng-container matColumnDef="viernes">
          <th mat-header-cell *matHeaderCellDef>Vie.</th>
          <td mat-cell *matCellDef="let exceptionRequest">
            {{ exceptionRequest.has_remote_work_friday | booleanToCheckCross }}
          </td>
        </ng-container>
        <ng-container matColumnDef="sabado">
          <th mat-header-cell *matHeaderCellDef>Sáb.</th>
          <td mat-cell *matCellDef="let exceptionRequest">
            {{ exceptionRequest.has_remote_work_saturday | booleanToCheckCross }}
          </td>
        </ng-container>
        <ng-container matColumnDef="domingo">
          <th mat-header-cell *matHeaderCellDef>Dom.</th>
          <td mat-cell *matCellDef="let exceptionRequest">
            {{ exceptionRequest.has_remote_work_sunday | booleanToCheckCross }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let exceptionRequest">
            <div class="actions-cell">
              <button mat-icon-button (click)="openReviewRemoteWorkRequestDialog(exceptionRequest)" matTooltip="Ver petición">
                <mat-icon>visibility</mat-icon>
              </button>

              <button mat-icon-button (click)="openApprovalStatusDialog(exceptionRequest)" matTooltip="Estado de aprobación">
                <mat-icon>info</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
